import bpAutoComplete from './bpAutoComplete';
import bpModule from './bpModule';

export default { businessProcess: bpModule, bpAutoComplete };
